import { render, staticRenderFns } from "./purchaseLog.vue?vue&type=template&id=4478453f"
import script from "./purchaseLog.vue?vue&type=script&lang=js"
export * from "./purchaseLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports